import styled from 'styled-components';
import Empty from './Empty';
type Props = {
  searchText?: string;
  onOpenAddNew?: (value: { name?: string, phone?: string }) => void;
};
const NotFoundCustomerBox = ({ }: Props) => {
  return (
    <Container>
      <Empty description='' />
    </Container>
  );
};

export default NotFoundCustomerBox;

const Container = styled.div`
  background: #fff;
  padding: 1rem;
  padding-top: 0;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
`;
